// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hf3w","toggleWrap":"styles_toggleWrap__3lEEe","content":"styles_content__2nOYF","selectAreaCode":"styles_selectAreaCode__1_RIc"};